import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardIndexPage } from './pages/index/index.component';
import { TranslateModule } from '@ngx-translate/core';
import { ArbolComponent } from './components/arbol/arbol.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { MostrarComponent } from './pages/mostrar/mostrar.component';
import { ClientesBackOfficeButtonModule } from '@global-components/shared';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [CommonModule, RouterModule, TranslateModule, NzTreeModule, ClientesBackOfficeButtonModule],
  declarations: [DashboardIndexPage, ArbolComponent, MostrarComponent],
  exports: [ArbolComponent],
})
export class DashboardModule {}
